export enum ChangeFlag {
    /** Change of cost center */
    CC = 'CC',
    /** Cost center change has impact to profit center change */
    CP = 'CP',
    /** Change of end date */
    CE = 'CE',
    /** Change of interest rate */
    CO = 'CO',
    /** Change of start date */
    CS = 'CS',
    /** Sublease type change */
    ST = 'ST',
    /** VIN number already exists but for different ARE (accounting unit) */
    RE = 'RE'
}
